export default __webpack_public_path__ + "static/media/internet.284089f5.png";